import React from "react";
import { ClipLoader } from "react-spinners";

import { AUTOPILOT_COLORS } from "components/autopilot/styles";

/**
 * Estado interno de UMA seção do indicador (PO1-3000 / PO1-3001).
 *
 * Cada seção nova consome um endpoint próprio e trata a própria falha: um 500
 * no /motivos não pode apagar a janela da auditoria da tela. Esta função
 * devolve o bloco que aparece no lugar do conteúdo enquanto carrega, quando o
 * endpoint falha ou quando não há nada para mostrar — e `null` quando há dado,
 * caso em que quem chama segue com o conteúdo normal.
 *
 * É uma função (e não um componente) de propósito: quem chama testa o retorno
 * com `if (bloco) return ...`, e um componente devolveria SEMPRE um elemento.
 */
export default function renderEstadoSecao(estado, vazio) {
  if (!estado) return null;

  if (estado.loading && !estado.data) {
    return (
      <div className="lt-secao-loading">
        <ClipLoader color={AUTOPILOT_COLORS.title} size={22} />
      </div>
    );
  }

  if (estado.error) {
    return <div className="lt-state lt-state--error">{estado.error}</div>;
  }

  if (!estado.data) {
    return <div className="lt-state">{vazio || "Sem dados no período."}</div>;
  }

  return null;
}
